import {User} from '../../shared/user/user.model';
export class Student {
    constructor(
        public id?: number,
        public dateOfBirth?: any,
        public mobilePhone?: string,
        public address?: string,
        public medicalCertificate?: boolean,
        public comments?: string,
        public profession?: string,
        public userId?: number,
        public schoolId?: number,
        public countryId?: number,
        public cityId?: number,
        public status?: any,
        public paidPercentage?: number,
        public sendPaymentReminderEnable?: boolean,
        public user?: User,
        public acceptOnlinePayments?: boolean
    ) {
        this.medicalCertificate = false;
        this.sendPaymentReminderEnable = false;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/student/student.model.ts